import { createApi } from '@reduxjs/toolkit/query/react'
import getQuery from '../../helpers/api/get-query'
import PrintQueueEntry from '../../types/api/print-queue-entry'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import getCustomFetchBase from '../custom-fetch-base'

export const printQueueEntriesApi = createApi({
    reducerPath: 'printQueueEntriesApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['PrintQueueEntries'],
    endpoints: builder => ({
        getPrintQueueEntries: builder.query<
            Strapi<PrintQueueEntry>,
            EndpointQueryParameters | void
        >({
            query: getQuery('/print-queue-entries'),
            providesTags: ['PrintQueueEntries'],
        }),
        createPrintQueueEntry: builder.mutation<
            StrapiSingle<PrintQueueEntry>,
            StrapiCreate<PrintQueueEntry>
        >({
            query: body => ({
                url: '/print-queue-entries',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['PrintQueueEntries'],
        }),
        updatePrintQueueEntry: builder.mutation<
            StrapiSingle<PrintQueueEntry>,
            StrapiUpdate<PrintQueueEntry>
        >({
            query: ({ docId, body }) => ({
                url: `/print-queue-entries/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['PrintQueueEntries'],
        }),
        reorderPrintQueueEntries: builder.mutation<
            any,
            { data: Pick<PrintQueueEntry, 'documentId' | 'sort'>[] }
        >({
            query: body => ({
                url: '/print-queue-entries/reorder',
                method: 'POST',
                body,
            }),
        }),
        deletePrintQueueEntry: builder.mutation<void, string>({
            query: docId => ({
                url: `/print-queue-entries/${docId}`,
                method: 'DELETE',
            }),
        }),
    }),
})

export const {
    useGetPrintQueueEntriesQuery,
    useLazyGetPrintQueueEntriesQuery,
    useCreatePrintQueueEntryMutation,
    useUpdatePrintQueueEntryMutation,
    useReorderPrintQueueEntriesMutation,
    useDeletePrintQueueEntryMutation,
} = printQueueEntriesApi
